import {SelectorIconComponent} from "../navigation/more/ui/selector-icon";

export enum UIType {
    LEFT                = 'left-nav', // GoodDay classic
    TOP                 = 'top-nav', // GoodDay Top
    ASANA               = 'asana',   // New
    TEAMS               = 'teams',   // New
    CLICK_UP            = 'click-up',   // New

    GOODDAY_MODERN      = 'goodday-modern',   // New

    SHARED_VIEW         = 'shared-view', // shared view case
}

export enum SkinTheme {
    LIGHT   = 'light',
    DARK    = 'dark'
}

export enum LayoutThemeUserSetting {
    LIGHT   = 'light',
    DARK    = 'dark',
    AUTO    = 'auto'
}

export enum LayoutFontSize {
    DEFAULT = 'default',
    SMALL   = 'small'
}

export enum NavigationBackground {
    BLUE        = 'blue',
    VIOLET      = 'violet',
    GREEN       = 'green',
    TURQUOISE   = 'turquoise',
    DARK        = 'dark',
    GRAY        = 'gray'
}

export enum MainMenuBackground {
    GRAY    = 'gray',
    WHITE   = 'white',
    DARK    = 'dark',
    PALE    = 'pale' // New. Used only in Goodday modern skin
}

export const themeOptions: Options = [
    {
        label: 'Light',
        value: LayoutThemeUserSetting.LIGHT,
        icon: "isvg-sun",
        iconComponent: SelectorIconComponent("isvg-sun")
    },
    {
        label: 'Dark',
        value: LayoutThemeUserSetting.DARK,
        icon: "isvg-moon",
        iconComponent: SelectorIconComponent("isvg-moon")
    },
    {
        label: 'Auto',
        value: LayoutThemeUserSetting.AUTO,
        icon: "isvg-auto",
        iconComponent: SelectorIconComponent("isvg-auto")
    }
]

export const navigationLayoutOptions: Options = [
    {
        value   : UIType.LEFT,
        label   : 'Left navigation'
    },
    {
        value   : UIType.TOP,
        label   : 'Top navigation'
    }
]

export type SkinOption = Option & {
    imagePath                      : string // New. Used in Skin & Layout Interface styles
    darkImagePath                  : string // New. Used in Skin & Layout Interface styles
}

export const skinOptions: SkinOption[] = [
    {
        value           : UIType.GOODDAY_MODERN,
        imagePath       : '/app/web/skin/common/svg/layout/light/modern.svg',
        darkImagePath   : '/app/web/skin/common/svg/layout/dark/modern.svg',
        // label           : 'Default Classic'
        label           : 'Modern'
    },
    {
        value           : UIType.LEFT,
        imagePath       : '/app/web/skin/common/svg/layout/light/default.svg',
        darkImagePath   : '/app/web/skin/common/svg/layout/dark/default.svg',
        // label           : 'Default Classic'
        label           : 'Default'
    },
    {
        value           : UIType.ASANA,
        imagePath       : '/app/web/skin/common/svg/layout/light/clean-flow.svg',
        darkImagePath   : '/app/web/skin/common/svg/layout/dark/clean-flow.svg',
        // label           : 'Clean Flow'
        label           : 'Dark Menu'
    },
    {
        value           : UIType.TEAMS,
        imagePath       : '/app/web/skin/common/svg/layout/light/compact-layout.svg',
        darkImagePath   : '/app/web/skin/common/svg/layout/dark/compact-layout.svg',
        // label           : 'Compact Layout'
        label           : 'Gray'
    },
    // {
    //     value           : UIType.CLICK_UP,
    //     imagePath       : '/app/web/skin/common/svg/layout/light/flexible-panel.svg',
    //     darkImagePath   : '/app/web/skin/common/svg/layout/dark/flexible-panel.svg',
    //     // label           : 'Flexible Panel'
    //     label           : 'Modern'
    // }
]

export const LightNavigationBgColorOptions: Options  = [
    {
        value: NavigationBackground.BLUE,
        label: "Blue"
    },
    {
        value: NavigationBackground.VIOLET,
        label: "Violet"
    },
    {
        value: NavigationBackground.GREEN,
        label: "Green"
    },
    {
        value: NavigationBackground.TURQUOISE,
        label: "Turquoise"
    },
    {
        value: NavigationBackground.DARK,
        label: "Dark"
    },
    {
        value: NavigationBackground.GRAY,
        label: "Gray"
    }
]

export const DarkNavigationBgColorOptions: Options  = [
    {
        value: NavigationBackground.BLUE,
        label: "Blue"
    },
    {
        value: NavigationBackground.VIOLET,
        label: "Violet"
    },
    {
        value: NavigationBackground.GREEN,
        label: "Green"
    },
    {
        value: NavigationBackground.TURQUOISE,
        label: "Turquoise"
    },
    {
        value: NavigationBackground.DARK,
        label: "Dark"
    }
]

export const MainMenuBgColorOptions: Options  = [
    {
        value: MainMenuBackground.GRAY,
        label: "Gray"
    },
    {
        value: MainMenuBackground.WHITE,
        label: "White"
    },
    {
        value: MainMenuBackground.PALE,
        label: "Pale"
    }
]

export const MainMenuBgColorOptionsWithDark: Options  = [
    {
        value: MainMenuBackground.GRAY,
        label: "Gray"
    },
    {
        value: MainMenuBackground.WHITE,
        label: "White"
    },
    {
        value: MainMenuBackground.DARK,
        label: "Dark"
    },
    {
        value: MainMenuBackground.PALE,
        label: "Pale"
    }
]

export const fontSizeOptions: Options = [
    {
        value: LayoutFontSize.DEFAULT,
        label: "Default"
    },
    {
        value: LayoutFontSize.SMALL,
        label: "Small"
    }
]
